import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/hr-outsourcing-services/$region")({
  component: () => <Outlet />,
});
